import { render, staticRenderFns } from "./pay-detail-table.vue?vue&type=template&id=3bdf64c0&scoped=true&"
import script from "./pay-detail-table.vue?vue&type=script&lang=js&"
export * from "./pay-detail-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdf64c0",
  null
  
)

export default component.exports